import React from "react";

function Dot() {
  return (
    <div className="login-dot-loading">
      <span className="dot"></span>
      <span className="dot"></span>
      <span className="dot"></span>
    </div>
  );
}

export default Dot;
